module.exports = __webpack_public_path__ + "static/vr-girl-5c5deed4f6868d5202a6440823ad9d98.png";